import React, { useCallback, useEffect, useState } from 'react'
import { DuesSkeleton } from '../../components/Skeleton'
import {
  BackLink,
  Card,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  PrimaryButton,
  Row,
  Stack,
} from '../../layout/styledComponents'
import { usePatient } from '../../context/PatientContext'
import * as svc from '../../services/shopService'

function fmtAmount(minor, currency = 'INR') {
  const major = (minor || 0) / 100
  if (currency === 'INR') return `₹${major.toLocaleString('en-IN')}`
  return `${currency} ${major}`
}

export default function DuesPage() {
  const { currentProfile } = usePatient()
  const [items, setItems] = useState(null)
  const [loading, setLoading] = useState(true)
  const [paying, setPaying] = useState(null)

  const refresh = useCallback(async () => {
    if (!currentProfile) return
    setLoading(true)
    try {
      const list = await svc.listDues(currentProfile)
      setItems(list)
    } finally {
      setLoading(false)
    }
  }, [currentProfile])

  useEffect(() => {
    setItems(null)
    refresh()
  }, [refresh])

  async function pay(due) {
    setPaying(due.id)
    try {
      await svc.payDue(currentProfile, due.id)
      await refresh()
    } finally {
      setPaying(null)
    }
  }

  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <BackLink to="/patient-home/shop">Back to Shop</BackLink>
        <div>
          <Pill>Shop</Pill>
          <PageHeading style={{ marginTop: 12 }}>Outstanding payments</PageHeading>
          <PageSubheading>Pay everything due in one place to unblock your next session.</PageSubheading>
        </div>

        {loading && !items ? (
          <DuesSkeleton />
        ) : !items?.length ? (
          <div
            style={{
              padding: '48px 24px',
              textAlign: 'center',
              border: '1px dashed rgba(31,41,55,0.18)',
              borderRadius: 20,
            }}
          >
            <p style={{ fontSize: 18, marginTop: 0, marginBottom: 8 }}>You&apos;re all caught up.</p>
            <Muted>No outstanding payments.</Muted>
          </div>
        ) : (
          <Stack $gap="10px">
            {items.map((due) => (
              <Card key={due.id}>
                <Row $between $gap="12px" $wrap>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>
                      {fmtAmount(due.amountMinor, due.currency)}
                    </div>
                    <Muted>{due.description}</Muted>
                    {due.dueLabel && <Muted style={{ marginTop: 4 }}>{due.dueLabel}</Muted>}
                  </div>
                  <PrimaryButton onClick={() => pay(due)} disabled={paying === due.id}>
                    {paying === due.id ? 'Processing…' : 'Pay'}
                  </PrimaryButton>
                </Row>
              </Card>
            ))}
          </Stack>
        )}
      </Stack>
    </ContentMaxWidth>
  )
}
